import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import type * as React from "react";
import { cn } from "@/lib/utils/index";
const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[colors,opacity,transform,box-shadow] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
  compoundVariants: [{
    className: "rounded-full",
    rounded: true,
    variant: "secondary"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "destructive"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "ghost"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "ghost-secondary"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "link"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "outline"
  }, {
    className: "rounded-full",
    rounded: true,
    variant: "default"
  }],
  defaultVariants: {
    rounded: false,
    size: "default",
    variant: "default"
  },
  variants: {
    rounded: {
      true: "rounded-full"
    },
    size: {
      default: "h-10 px-4 py-2 has-[>svg]:px-3",
      icon: "size-8",
      lg: "h-13 rounded-md px-6 has-[>svg]:px-4",
      sm: "h-7 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5 [&_svg:not([class*='size-'])]:size-3.5"
    },
    variant: {
      default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
      destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
      ghost: "hover:bg-accent/20 text-accent-foreground/80 hover:text-accent-foreground dark:hover:bg-accent/50",
      "ghost-secondary": "hover:bg-secondary/20 dark:hover:bg-secondary/50",
      link: "text-accent underline-offset-4 hover:underline",
      outline: "border bg-background shadow-xs hover:bg-primary/5 dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
      secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80"
    }
  }
});
export type ButtonProps = React.ComponentProps<"button"> & VariantProps<typeof buttonVariants> & {
  asChild?: boolean;
};
function Button(t0) {
  const $ = _c(16);
  let className;
  let props;
  let rounded;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      rounded,
      size,
      asChild: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = rounded;
    $[4] = size;
    $[5] = t1;
    $[6] = variant;
  } else {
    className = $[1];
    props = $[2];
    rounded = $[3];
    size = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  let t2;
  if ($[7] !== className || $[8] !== rounded || $[9] !== size || $[10] !== variant) {
    t2 = cn(buttonVariants({
      className,
      rounded,
      size,
      variant
    }));
    $[7] = className;
    $[8] = rounded;
    $[9] = size;
    $[10] = variant;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== Comp || $[13] !== props || $[14] !== t2) {
    t3 = <Comp className={t2} data-slot="button" {...props} />;
    $[12] = Comp;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
function SubmitButton(t0) {
  const $ = _c(11);
  let children;
  let isSubmitting;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      isSubmitting,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isSubmitting;
    $[3] = props;
  } else {
    children = $[1];
    isSubmitting = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== isSubmitting) {
    t1 = isSubmitting ? <Loader2 className="size-4 animate-spin" /> : null;
    $[4] = isSubmitting;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== isSubmitting || $[8] !== props || $[9] !== t1) {
    t2 = <Button disabled={isSubmitting} {...props}>{t1}{children}</Button>;
    $[6] = children;
    $[7] = isSubmitting;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
export { Button, buttonVariants, SubmitButton };